import { Options } from 'ngx-slider-v2';

/** Time slider option constants */
export const TIME_SLIDER_OPTIONS = {
	VALUE: 8,
	HIGH_VALUE: 17,
	OPTIONS: {
		floor: 8,
		ceil: 17,
		step: 0.5,
		translate: (value: number): string => {
			// Values to be displayed on Slider
			// If time is after 12, converting to 12 Hour format
			if (value >= 12) {
				// If number is not decimal, appending with '00'
				if (value % 1 === 0) {
					if (value === 12) {
						return value + ':00 PM';
					} else {
						return value - 12 + ':00 PM';
					}
				} else {
					// If number is decimal, appending with '30'
					if (value === 12.5) {
						return Math.floor(value) + ':30 PM';
					} else {
						return Math.floor(value) - 12 + ':30 PM';
					}
				}
			} else {
				if (value % 1 === 0) {
					// If number is not decimal, appending with '00'
					return value + ':00 AM';
				} else {
					// If number is not decimal, appending with '00'
					return Math.floor(value) + ':30 AM';
				}
			}
		},
	},
};

/** Health history time slider options constants */
export const HEALTH_HISTORY_OPTIONS = {
	VALUE: 0,
	HIGH_VALUE: 10,
	OPTIONS: {
		floor: 1,
		ceil: 10,
		step: 1,
	},
};
